export default "__VITE_ASSET__C9N5sF0U__"